import React from 'react';
import { Table, Tag } from 'antd';
import moment from 'moment';

import { DAYTIME_FORMAT, DAY_FORMAT, SPARQLE_DARK_BLUE } from '../../constants';
import './CompaniesTable.scss';
import './OrdersTable.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const OrdersTable = ({ withAction, dataSource, selectedRowKeys, onSelectChange, ...props }) => {
  const history = useHistory();

  const columns = [
    // {
    //   title: '',
    //   key: 'carrierId',
    //   fixed: 'left',
    //   width: 50,
    //   render: (row) => {
    //     if (row?.carrier) {
    //       return (
    //         <div className="logo">
    //           <Tooltip title={row.carrier?.name}>
    //             <img
    //               src={
    //                 process.env.REACT_APP_S3_URL + row.carrier?.logoThumb ||
    //                 `https://ui-avatars.com/api/?length=1&name=${row.carrier?.name}&size=32&font-size=0.4&bold=true&background=${COLOR_DEFAULT}&color=${SPARQLE_DARK_BLUE}&rounded=true`
    //               }
    //               style={{ borderRadius: '50%' }}
    //             />
    //           </Tooltip>
    //         </div>
    //       );
    //     }
    //   },
    // },
    {
      title: 'Order ID',
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: 'left',
      width: 150,
      render: (text, record) => (
        <a
          onClick={(e) => {
            // Check if Ctrl (Windows/Linux) or Cmd (Mac) is pressed
            if (e.ctrlKey || e.metaKey) {
              window.open(`/orders/${record.orderId}`, '_blank'); // Open in new tab
            } else {
              history.push(`/orders/${record.orderId}`); // Navigate in the same tab
            }
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: 'Order Ref',
      dataIndex: 'orderRef',
      key: 'orderRef',
      width: 150,
    },
    {
      title: 'Delivery Date',
      dataIndex: 'deliveryDate',
      key: 'deliveryDate',
      width: 150,
      render: (value) => {
        return value ? moment(value).format(DAY_FORMAT) : '';
      },
    },
    {
      title: 'Company',
      key: 'Company',
      className: 'order-companies',
      width: 200,
      render: (row) => {
        if (row.location?.company) {
          return (
            <div>
              <div className="logo">
                <img src={row.location?.company?.logoThumbUrl || row.location?.company?.logoUrl} />
              </div>
              {row.location?.company?.name}
            </div>
          );
        }
      },
    },
    {
      title: 'Pickup Name',
      dataIndex: 'pickupName',
      key: 'pickupName',
      width: 250,
    },
    {
      title: 'Pickup Address',
      dataIndex: 'pickupAddress',
      width: 400,
      key: 'pickupAddress',
    },

    {
      title: 'Delivery Name',
      dataIndex: 'deliveryName',
      key: 'deliveryName',
      width: 250,
    },
    {
      title: 'Delivery Address',
      dataIndex: 'deliveryAddress',
      key: 'deliveryAddress',
      width: 450,
    },
    {
      title: 'Load',
      dataIndex: 'load',
      key: 'load',
      width: 80,
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 150,
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
    {
      title: 'Claim',
      dataIndex: 'claimStatus',
      key: 'claim',
      fixed: 'left',
      width: 90,
      render: (v) => (v ? <Tag color={`#${SPARQLE_DARK_BLUE}`}>{v[0].concat(v.slice(1).toLowerCase())}</Tag> : <></>),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      fixed: 'right',
      width: 160,
      key: 'status',
      render: (value) => {
        return <span className={'status orders ' + value?.toLowerCase()}>{value?.split('_').join(' ')}</span>;
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 120,
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-orders table-common">
      <Table
        columns={columns}
        rowSelection={rowSelection}
        scroll={{ x: 2650 }}
        dataSource={dataSource}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
};

export default OrdersTable;
